import { render, staticRenderFns } from "./ProPatientsCPage.vue?vue&type=template&id=7dc42220"
import script from "./ProPatientsCPage.vue?vue&type=script&lang=js"
export * from "./ProPatientsCPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports